const state = {
  drawer: true,
  mini: false,
};

const getters = {
  drawer: (state) => state.drawer,
  mini: (state) => state.mini,
};

const actions = {
  toggleDrawer({ commit }) {
    commit("TOGGLE_DRAWER");
  },
  toggleMini({ commit }) {
    commit("TOGGLE_MINI");
  },
  setDrawer({ commit }, value) {
    commit("SET_DRAWER", value);
  },
  setMini({ commit }, value) {
    commit("SET_MINI", value);
  },
};

const mutations = {
  TOGGLE_DRAWER(state) {
    state.drawer = !state.drawer;
  },
  TOGGLE_MINI(state) {
    state.mini = !state.mini;
  },
  SET_DRAWER(state, value) {
    state.drawer = value;
  },
  SET_MINI(state, value) {
    state.mini = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
